import React from 'react'
import { Switch, Route } from 'react-router-dom'
import hotelRoutes from './hotelRoutes.config'

function HotelRoutes(props) {
    return (
        <Switch>
            {hotelRoutes.map((route, i) => (
                <Route {...route} key={i} />
            ))}
        </Switch>
    )
}

export default HotelRoutes
